/*
 *
 * TtlCountdown
 *
 * @version 1.0.0
 * @author Magarelli_Fabrizio
 * @since 01-Oct-2024
 */

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import TtlCountdown from './TtlCountdown'

const mapDispatchToProps = {}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(TtlCountdown)
